export default "__VITE_ASSET__60A0wZ3o__"